export const scrollToTop = (behavior: "auto" | "smooth" = "smooth"): void => {
  window.scrollTo({
    top: 0,
    behavior,
  })
}
